<div class="snack-data-container">
    <mat-icon color="accent">remove_red_eye</mat-icon><p>{{data}}</p><button (click)="dismiss()"><mat-icon class="close-icon">close</mat-icon></button>
</div>
